// extracted by mini-css-extract-plugin
module.exports = {"Banned":"Banned_Banned__LQ2jb","InfoCard":"Banned_InfoCard__1QFqT","Title":"Banned_Title__3X0dV","Text":"Banned_Text__fE1hg","Button":"Banned_Button__3btnK"};